<template>
  <div class="rating">
    <div class="stars">
      <div v-for="option in scoreOptions" :key="option.value">
        <input
          type="radio"
          :id="'star1_' + option.value"
          name="rating1"
          :value='option.value'
          required
          v-model="rating">
        <label :for="'star1_' + option.value" :title="option.value + ' star'" :class="{ gold: option.value <= rating }">
          <i class="fa fa-star"
            @mouseover="hoveredText = option.hint"
            @mouseleave="hoveredText = null" />
        </label>
      </div>
    </div>
    <div class="hint">
      <span class="hint_sizer">{{ texts[0] }}</span>
      <span class="hint_text">{{ hoveredText || ratingText || texts[0] }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['texts'],
  data() {
    return {
      rating: null,
      hoveredText: null
    }
  },
  computed: {
    ratingText() {
      return this.scoreOptions[5 - this.rating]?.hint
    }
  },
  created() {
    this.scoreOptions = ['Awesome', 'Good', 'Okay', 'Disappointing', 'Horrible'].map((label, i) => ({ value: 5 - i, hint: this.texts[5 - i] || label }))
  },
  watch: {
    rating(val) {
      this.$emit('on-change-score', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~stylesheets/feedback_page/variables';
@import '~stylesheets/feedback_page/stars';
</style>
